exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dis-flex{display:flex}.applyFromCom{width:100%;overflow:hidden}.applyFromCom-item{display:flex;flex-direction:row;align-items:center;margin-bottom:2.66667vw;font-size:3.73333vw}.applyFromCom-item__label{flex-grow:0;flex-shrink:0;width:16vw;padding-right:2.66667vw;text-align:right;font-size:3.73333vw}.applyFromCom-item__control{height:10.66667vw}.applyFromCom .btn-submit{width:26.66667vw;height:10.66667vw;border-radius:1.06667vw;border:.26667vw solid #ccc;display:flex;align-items:center;justify-content:center;font-size:3.73333vw}\n", ""]);

// exports
